import React from 'react';
import AnimatedButton from '../../custom/AnimatedButton';
import LanguageUtil from '../../../util/LanguageUtil';
import { SarValidationResult } from '../SarInterfaces';

const SarActionFooter = ({ onValidate, onCancel, onApply, validate, xmlContent }: SarActionFooterProps) => {
  return (
    <footer className={' bg-white px-6 py-4 flex items-center justify-between'}>
      <div className={'flex items-center gap-x-3'}>
        <AnimatedButton
          className={'text-[11px]'}
          onClick={onValidate}
          icon={'deploy'}
          text={LanguageUtil.get({ id: 'common.label.validate' })}
          customSize={'sm'}
          customType={'outlined'}
        />
        {validate && (
          <div className={'flex items-center gap-x-2'}>
            <span className={`text-sm font-semibold ${validate.isValid ? 'text-[#50A67F]' : 'text-[#D2332F]'}`}>{validate.isValid ? 'Valid' : 'Invalid'}</span>
          </div>
        )}
      </div>
      <div className={'flex gap-x-4'}>
        <AnimatedButton
          className={'text-[11px]'}
          onClick={onCancel}
          icon={'multiplier'}
          text={LanguageUtil.get({ id: 'common.label.cancel', defaultMessage: 'Cancel' })}
          customSize={'sm'}
          customType={'secondary'}
        />
        <AnimatedButton
          className={'text-[11px]'}
          onClick={onApply}
          icon={'check'}
          text={LanguageUtil.get({ id: 'common.label.download', defaultMessage: 'Download' })}
          customSize={'sm'}
          customType={'primary'}
          disabled={xmlContent == undefined}
        />
      </div>
    </footer>
  );
};

interface SarActionFooterProps {
  readonly onValidate: () => void;
  readonly onCancel: () => void;
  readonly onApply: () => void;
  readonly validate: SarValidationResult | undefined;
  readonly xmlContent?: string;
}
export default SarActionFooter;
